import { gql } from '@apollo/client'

import { CUSTOMER_ADDRESS_FRAGMENT } from '../../fragments/customer/address'

export const CREATE_CUSTOMER_ADDRESS = gql`
  mutation CreateCustomerAddress($input: CreateCustomerAddressInput!) {
    createCustomerAddress(input: $input) {
      customerAddress {
        ...CustomerAddress
      }
    }
  }
  ${CUSTOMER_ADDRESS_FRAGMENT}
`
